import React from "react";

// locales
import i18n from '../i18n';
// the hoc
import { withTranslation } from 'react-i18next';

// components
import SelectArtistTitle from "./select/SelectArtistTitle";
import SelectType from "./select/SelectType";
import SelectPeriod from "./select/SelectPeriod";
import SelectTheme from "./select/SelectTheme";
import SelectLocation from "./select/SelectLocation";

// utils
import { IS_DEBUG } from '../utils/isdebug';
// import { SEARCH } from "../utils/const";

// style
import "./Collapse.scss";

class Collapse extends React.Component {

	tabArr = [];

	constructor(props) {
		super(props);
		this.tabArr = i18n.t('collapse.title.array', { returnObjects: true });
		this.state = {
			collapseState: '',
			isPanelClosed: true,
		};
	}

	// ____________________________________ getPanelSelected ____________________________________

	getPanelSelected() {
		let template;
		switch (this.state.collapseState) {
			case this.tabArr[0]:
				// artist
				template = <SelectArtistTitle
					onClick={this.props.onArtistTitleClick}
					onApplyClick={this.props.onApplyClick}
					autocompleteArray={this.props.autocompleteArray}
					selectedState={this.state.collapseState}
				/>
				break;
			case this.tabArr[1]:
				// type
				template = <SelectType
					onClick={this.props.onTypeClick}
					onApplyClick={this.props.onApplyClick}
					typeArray={this.props.typeArray}
					selectedState={this.state.collapseState}
				/>
				break;
			case this.tabArr[2]:
				// period
				template = <SelectPeriod
					onClick={this.props.onPeriodClick}
					onApplyClick={this.props.onApplyClick}
					onPeriodBetweenClick={this.props.onPeriodBetweenClick}
					periodArray={this.props.periodArray}
					selectedState={this.state.collapseState}
				/>
				break;
			case this.tabArr[3]:
				// theme
				template = <SelectTheme
					onClick={this.props.onThemeClick}
					onApplyClick={this.props.onApplyClick}
					themeArray={this.props.themeArray}
					themeImgArray={this.props.themeImgArray}
					selectedState={this.state.collapseState}
				/>
				break;
			case this.tabArr[4]:
				// location
				template = <SelectLocation
					onClick={this.props.onLocationClick}
					onApplyClick={this.props.onApplyClick}
					locationArray={this.props.locationArray}
					selectedState={this.state.collapseState}
				/>
				break;
			default:
				// // location
				// template = <SelectLocation
				// 	onClick={this.props.onLocationClick}
				// 	onApplyClick={this.props.onApplyClick}
				// 	locationArray={this.props.locationArray}
				// 	selectedState={this.state.collapseState}
				// />
				break;
		}
		return template
	}


	// ____________________________________ onHandlers ____________________________________

	/**
	 * check if is closed (`isPanelClosed:true`)
	 * check if is open already (`isPanelClosed:false`)
	 * check if is open on same `val` (`'Theme' === 'Theme'`)
	 * check if is open and must stay open ('Theme === 'Location'')
	 */
	onTabToggleHandler(e, val) {
		e.preventDefault();
		// console.log(val);
		// console.log(e, val);
		let isSameState = false;
		if (val === this.state.collapseState) {
			isSameState = true;
			val = '';
		}
		this.setState({
			collapseState: val,
			isPanelClosed: isSameState,
		});
	}

	onResetHandler() {
		// console.log('reset');
		this.setState({
			collapseState: '',
			isPanelClosed: true,
			// isPreviousSearchSelected: false,
		});
		this.props.onReset();
	}

	// ____________________________________ toggle ____________________________________

	isPanelClosed() {

		// console.log('this.state.collapseState: "' + this.state.collapseState + '"');
		// console.log('isSearchSelected: ' + this.props.isSearchSelected.toString());
		// console.log('searchType: ' + this.props.searchType.toString());
		// console.log('searchTypeDetail: ' + this.props.searchTypeDetail.toString());

		/////////////////////////////////////////
		// console.log(this.state.collapseState === '');
		// console.log('this.state.isPanelClosed: ' + this.state.isPanelClosed);
		// console.log('this.state.collapseState: "' + this.state.collapseState + '"');
		// console.log('this.props.isSearchSelected: ' + this.props.isSearchSelected);

		var _isClosed = false;

		if (this.state.isPanelClosed) {
			// if (IS_DEBUG()) {
			// 	console.group('isPanelClosed');
			// 	console.log('this.state.isPanelClosed: ' + this.state.isPanelClosed);
			// 	console.groupEnd();
			// }
			_isClosed = true;
		}

		if (this.state.collapseState === '' && this.props.isSearchSelected) {
			// if (IS_DEBUG()) {
			// 	console.group('isSearchSelected');
			// 	console.log('this.state.collapseState: ' + this.state.collapseState);
			// 	console.log('this.props.isSearchSelected: ' + this.props.isSearchSelected.toString());
			// 	console.groupEnd();
			// }
			_isClosed = true;
		}

		if (this.state.isPanelClosed && this.state.collapseState === '' && this.props.isSearchSelected) {
			// if (IS_DEBUG()) {
			// 	console.group('&&');
			// 	console.log('this.state.isPanelClosed: ' + this.state.isPanelClosed);
			// 	console.log('this.state.collapseState: ' + this.state.collapseState);
			// 	console.log('this.props.isSearchSelected: ' + this.props.isSearchSelected);
			// 	console.groupEnd();
			// }
			_isClosed = true;
		}

		if (this.state.collapseState === this.props.searchType) {
			// if (IS_DEBUG()) {
			// 	console.group('xx');
			// 	console.log('this.state.collapseState: ' + this.state.collapseState);
			// 	console.log('this.props.searchType: ' + this.props.searchType);
			// 	console.groupEnd();
			// }
			_isClosed = true;
		}

		return _isClosed;


		// if ((this.state.isPanelClosed || this.props.isSearchSelected) && (this.state.collapseState === this.props.searchType)) {
		// 	return true;
		// } else {
		// 	return false;
		// }
	}

	// ____________________________________ tab button with correct innerText and onClick handler ____________________________________

	getTab(value) {
		// default vars
		var _onclickHandler = (e) => this.onTabToggleHandler(e, value);
		var cssName = (this.state.collapseState === value) ? ' active' : '';
		var linkText = value;
		// make sure to use different values when searchType is eq to this one
		if (this.props.searchType === value) {
			linkText = `${this.props.searchTypeDetail}`;
			cssName = ' nav-link-selected';
			_onclickHandler = (e) => this.onResetHandler(e);
		}

		var template = <a
			onClick={_onclickHandler}
			className={`nav-link ${cssName}`}
			href={"#" + value}
			data-href={"#" + value}>{linkText}</a>

		return template;
	}

	// ____________________________________ render ____________________________________

	render() {
		return (
			<>
				<div className="container-collapse">

					{this.debugComponents()}

					{/* {this.debugCssComponents()} */}

					<ul className="nav nav-tabs nav-fill nav-ing-tabs">
						{
							this.tabArr.map((value, key) =>
								<li className="nav-item" key={key}>
									{this.getTab(value)}
									{/* <a
										onClick={(e) => this.onTabToggleHandler(e, value)}
										className={`nav-link ${(this.state.collapseState === value) ? ' active' : ''}`}
										href={"#" + value}
										data-href={"#" + value}>{value}</a> */}
								</li>
							)
						}
					</ul>
					<div className={`container-border ${(this.isPanelClosed()) ? 'collapse' : 'collapsed'}`} id="collapseArtistTitle">
						<div className="card-body">
							{(this.getPanelSelected())}
						</div>
					</div>
				</div>
			</>
		);
	}

	// ____________________________________ debug ____________________________________

	debugComponents() {
		var template = null;
		if (IS_DEBUG()) template =
			<div className="alert alert-warning">
				<a className="btn btn-outline-dark btn-ing" href="#reset" onClick={(e) => this.onResetHandler()} >Reset</a>
				<h6>Collapse.js</h6>
				<ul>
					<li>this.state.isPanelClosed: '{this.state.isPanelClosed.toString()}'</li>
					<li>this.state.collapseState: '{this.state.collapseState.toString()}'</li>
					<li>this.props.isSearchSelected: '{this.props.isSearchSelected.toString()}'</li>
					<li>this.props.searchType: '{this.props.searchType.toString()}'</li>
					<li>this.props.searchTypeDetail: '{this.props.searchTypeDetail.toString()}'</li>
				</ul>
			</div>
		return template;
	}

	debugCssComponents() {
		var ttt = ["Artist/title",
			"Type",
			"Period",
			"Theme",
			"Location"]
		var template = null;
		if (IS_DEBUG()) template =
			<ul className="nav nav-tabs nav-fill nav-ing-tabs">
				{
					ttt.map((value, key) =>
						<li className="nav-item" key={key} >

							{/* <a href={"#_" + value} className="nav-link nav-link-selected">test</a> */}
							<a
								onClick={(e) => this.onTabToggleHandler(e, value)}
								className={`nav-link ${(this.state.collapseState === value) ? ' active' : ''}`}
								href={"#" + value}
								data-href={"#" + value}>{value}</a>
						</li>
					)
				}
				<li className="nav-item"><a className="nav-link active" href="#ssss">active</a></li>
				<li className="nav-item"><a className="nav-link active _nav-link-selected" href="#ssss">nav-link-selected</a></li>
			</ul>
		return template;
	}

}

export default withTranslation()(Collapse);